import {
    apiRequest,
    AcManajerialData,
    AcManajerialDetail,
    AcManajerialStankom,
    AcManajerialMatrix,
    AcDevGuide,
    SuitablePossision
} from "../../../../../services/adapters/Assesment/assesmentService"

class DetailRepository {

    fetchAcData = async (query) => {
        return await apiRequest("get", AcManajerialData, {
            params: query
        }, true)
    }
    fetchAcDetail = async (query) => {
        return await apiRequest("get", AcManajerialDetail, {
            params: query
        }, true)
    }
    fetchStankom = async (query) => {
        return await apiRequest("get", AcManajerialStankom, {
            params: query
        }, true)
    }
    fetchMatrix = async (query) => {
        return await apiRequest("get", AcManajerialMatrix, {
            params: query
        }, true)
    }
    fetchDevGuide = async (query) => {
        return await apiRequest("get", AcDevGuide, {
            params: query
        }, true)
    }
    fetchSuitablePossision = async (query) => {
        return await apiRequest("get", SuitablePossision, {
            params: query
        }, true)
    }
}

export default DetailRepository